/* eslint-disable eqeqeq */

export function calculateBetExpouser(market, runner, type, value, price, isLive) {
    let exp = {}
    if ((market.marketType === "BOOKMAKER" || market.marketType === "SPECIAL_MAKER" || market.marketType === "MINI_BOOKMAKER" || market.marketType === "MINI_MATCH_ODDS") && isLive) {
        if (type === "back") {
            market.runners.forEach(rn => {
                if (rn.id == runner) {
                    exp[rn.id] = ((parseFloat(price)) * parseFloat(value)) / 100
                } else {
                    exp[rn.id] = (0 - parseFloat(value))
                }
                exp[rn.id] = exp[rn.id].toFixed(2)

            });
        } else if (type === "lay") {
            market.runners.forEach(rn => {
                if (rn.id == runner) {
                    exp[rn.id] = (0 - ((parseFloat(price)) * parseFloat(value))) / 100
                } else {
                    exp[rn.id] = (parseFloat(value))
                }
                exp[rn.id] = exp[rn.id].toFixed(2)

            });
        }
    } else {
        const runners = window.location.pathname === '/binary' ? market.catalogue.runners : market.runners
        if (type === "back") {
            runners.forEach(rn => {
                if (rn.id == runner) {
                    exp[rn.id] = (parseFloat(price) - 1) * parseFloat(value)
                } else {
                    exp[rn.id] = 0 - parseFloat(value)
                }
                exp[rn.id] = exp[rn.id].toFixed(2)

            });
        } else if (type === "lay") {
            runners.forEach(rn => {
                if (rn.id == runner) {
                    exp[rn.id] = 0 - ((parseFloat(price) - 1) * parseFloat(value))
                } else {
                    exp[rn.id] = parseFloat(value)
                }
                exp[rn.id] = exp[rn.id].toFixed(2)

            });
        }
    }
    return exp
}

export function calculateExpouser(market, runner, type, value, price, mktBets) {
    let baseExpo = calculateBetExpouser(market, runner, type, value, price, true)
    let demoExpo = JSON.parse(sessionStorage.getItem('demoExpo')) || {}
    mktBets.forEach((bet) => {
        if (market.marketId === bet.marketId) {
            let betExpo = calculateBetExpouser(market, bet.runnerId, bet.side.toLowerCase(), bet.amount, bet.price, true)
            Object.keys(baseExpo).forEach((rnr) => {
                baseExpo[rnr] = parseFloat(baseExpo[rnr]) + parseFloat(betExpo[rnr])
            })
        }
    })
    // debugger
    const prfdt = JSON.parse(localStorage.getItem('profData'));
    if (!!prfdt && prfdt.role === 'DemoClient') {
        let expvlarr = Object.values(baseExpo)
        demoExpo[market.marketId] = Math.min(...expvlarr);
        sessionStorage.setItem('demoExpo', JSON.stringify(demoExpo));
    }
    return baseExpo
}
export function calculateFancyMktExpouser(market, mktBets) {
    let demoExpo = JSON.parse(sessionStorage.getItem('demoExpo'))
    let expo = 0
    let mktLines = mktBets.map((bet) => { return bet = bet.runnerId })
    let minLine = Math.min(...mktLines) > 0 ? Math.min(...mktLines) - 1 : Math.min(...mktLines)
    let maxLine = Math.max(...mktLines) + 1
    let lineExpos = {}
    for (let i = minLine; i <= maxLine; i++) {
        let curLine = i
        let lineExpo = 0.00
        mktBets.forEach((bet, index) => {
            if (bet.side.toLowerCase() === "back") {
                if (bet.runnerId <= curLine) {
                    lineExpo = parseFloat(lineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                } else {
                    lineExpo = parseFloat(lineExpo) - parseFloat(bet.amount)
                }
            } else if (bet.side.toLowerCase() === "lay") {
                if (bet.runnerId > curLine) {
                    lineExpo = parseFloat(lineExpo) + parseFloat(bet.amount)
                } else {
                    lineExpo = parseFloat(lineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                }
            }

        })
        lineExpos[curLine] = { expo: lineExpo }
    }
    let lineExpoArr = Object.keys(lineExpos).map((line) => { return line = lineExpos[line].expo })
    // debugger
    expo = Math.min(...lineExpoArr)

    const prfdt = JSON.parse(localStorage.getItem('profData'));
    if (!!prfdt && prfdt.role === 'DemoClient') {
        demoExpo[market.marketId] = expo;
        sessionStorage.setItem('demoExpo', JSON.stringify(demoExpo));
    }
    let data = { expo: expo, lineExpos: lineExpos }
    return data
}

export function calculateFancyMktExpouserDemo(market, mktBets) {
    // let demoExpo = JSON.parse(sessionStorage.getItem('demoExpo'))
    let expo = 0
    let mktLines = mktBets.map((bet) => { return bet = bet.runnerId })
    let minLine = Math.min(...mktLines) > 0 ? Math.min(...mktLines) - 1 : Math.min(...mktLines)
    let maxLine = Math.max(...mktLines) + 1
    let lineExpos = {}
    for (let i = minLine; i <= maxLine; i++) {
        let curLine = i
        let lineExpo = 0.00
        mktBets.forEach((bet, index) => {
            if (bet.side.toLowerCase() === "back") {
                if (bet.runnerId <= curLine) {
                    lineExpo = parseFloat(lineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                } else {
                    lineExpo = parseFloat(lineExpo) - parseFloat(bet.amount)
                }
            } else if (bet.side.toLowerCase() === "lay") {
                if (bet.runnerId > curLine) {
                    lineExpo = parseFloat(lineExpo) + parseFloat(bet.amount)
                } else {
                    lineExpo = parseFloat(lineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                }
            }

        })
        lineExpos[curLine] = { expo: lineExpo }
    }
    let lineExpoArr = Object.keys(lineExpos).map((line) => { return line = lineExpos[line].expo })
    // debugger
    expo = Math.min(...lineExpoArr)

    // const prfdt = JSON.parse(localStorage.getItem('profData'));
    // if (!!prfdt && prfdt.role === 'DemoClient') {
    //     demoExpo[market.marketId] = expo;
    //     sessionStorage.setItem('demoExpo', JSON.stringify(demoExpo));
    // }
    let data = { expo: expo, lineExpos: lineExpos }
    return data
}

export function calculateBinMktExpouser(market, mktBets) {
    let expo = 0
    let mktLines = mktBets.map((bet) => { return bet = bet.runnerId })
    let minLine = Math.min(...mktLines) > 0 ? Math.floor(Math.min(...mktLines) - 1) : Math.floor(Math.min(...mktLines)) //Math.min(...mktLines) > 0 ? Math.min(...mktLines) - 1 : Math.min(...mktLines)
    // minLine = minLine.toFixed(4)
    let maxLine = Math.floor(Math.ceil(...mktLines) + 1)//Math.max(...mktLines) + 1
    // maxLine = maxLine.toFixed(4)
    let lineExpos = {}

    for (let i = minLine; i <= maxLine; i++) { //i+=0.0001) {

        let curLine = parseFloat(i).toFixed(4)
        let lineExpo = 0.00

        mktBets.forEach((bet, index) => {
            if (bet.side.toLowerCase() === "back") {
                if (bet.runnerId <= curLine) {
                    lineExpo = parseFloat(lineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                } else {
                    lineExpo = parseFloat(lineExpo) - parseFloat(bet.amount)
                }
            } else if (bet.side.toLowerCase() === "lay") {
                if (bet.runnerId > curLine) {
                    lineExpo = parseFloat(lineExpo) + parseFloat(bet.amount)
                } else {
                    lineExpo = parseFloat(lineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                }
            }

        })

        if (mktLines.includes(i)) {
            let prvLine = (parseFloat(i) - 0.0001000000000).toFixed(4)
            let nxtLine = (parseFloat(i) + 0.0001000000000).toFixed(4)
            let prvLineExpo = 0.00
            let nxtLineExpo = 0.00
            mktBets.forEach((bet, index) => {
                if (bet.side.toLowerCase() === "back") {
                    if (bet.runnerId <= prvLine) {
                        prvLineExpo = parseFloat(prvLineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                    } else {
                        prvLineExpo = parseFloat(prvLineExpo) - parseFloat(bet.amount)
                    }
                } else if (bet.side.toLowerCase() === "lay") {
                    if (bet.runnerId > prvLine) {
                        prvLineExpo = parseFloat(prvLineExpo) + parseFloat(bet.amount)
                    } else {
                        prvLineExpo = parseFloat(prvLineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                    }
                }

            })
            mktBets.forEach((bet, index) => {
                if (bet.side.toLowerCase() === "back") {
                    if (bet.runnerId <= nxtLine) {
                        nxtLineExpo = parseFloat(nxtLineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                    } else {
                        nxtLineExpo = parseFloat(nxtLineExpo) - parseFloat(bet.amount)
                    }
                } else if (bet.side.toLowerCase() === "lay") {
                    if (bet.runnerId > nxtLine) {
                        nxtLineExpo = parseFloat(nxtLineExpo) + parseFloat(bet.amount)
                    } else {
                        nxtLineExpo = parseFloat(nxtLineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                    }
                }

            })

            lineExpos[prvLine] = { expo: prvLineExpo }
            lineExpos[curLine] = { expo: lineExpo }
            lineExpos[nxtLine] = { expo: nxtLineExpo }
        } else {
            lineExpos[curLine] = { expo: lineExpo }
            let isAterThisButBeforeNext = null
            for (let itm = 0; itm < mktLines.length; itm++) {
                if (mktLines[itm] > i && mktLines[itm] < i + 1) {
                    isAterThisButBeforeNext = mktLines[itm];
                    mktLines.splice(itm, 1)
                    break;
                }
            }
            if (!!isAterThisButBeforeNext) {
                let prvLine = (parseFloat(isAterThisButBeforeNext) - 0.0001000000000).toFixed(4)
                let thisLine = parseFloat(isAterThisButBeforeNext).toFixed(4)
                let nxtLine = (parseFloat(isAterThisButBeforeNext) + 0.0001000000000).toFixed(4)
                let prvLineExpo = 0.00
                let thisLineExpo = 0.00
                let nxtLineExpo = 0.00
                mktBets.forEach((bet, index) => {
                    if (bet.side.toLowerCase() === "back") {
                        if (bet.runnerId <= prvLine) {
                            prvLineExpo = parseFloat(prvLineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                        } else {
                            prvLineExpo = parseFloat(prvLineExpo) - parseFloat(bet.amount)
                        }
                    } else if (bet.side.toLowerCase() === "lay") {
                        if (bet.runnerId > prvLine) {
                            prvLineExpo = parseFloat(prvLineExpo) + parseFloat(bet.amount)
                        } else {
                            prvLineExpo = parseFloat(prvLineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                        }
                    }

                })
                mktBets.forEach((bet, index) => {
                    if (bet.side.toLowerCase() === "back") {
                        if (bet.runnerId <= thisLine) {
                            thisLineExpo = parseFloat(thisLineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                        } else {
                            thisLineExpo = parseFloat(thisLineExpo) - parseFloat(bet.amount)
                        }
                    } else if (bet.side.toLowerCase() === "lay") {
                        if (bet.runnerId > thisLine) {
                            thisLineExpo = parseFloat(thisLineExpo) + parseFloat(bet.amount)
                        } else {
                            thisLineExpo = parseFloat(thisLineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                        }
                    }

                })
                mktBets.forEach((bet, index) => {
                    if (bet.side.toLowerCase() === "back") {
                        if (bet.runnerId <= nxtLine) {
                            nxtLineExpo = parseFloat(nxtLineExpo) + parseFloat((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                        } else {
                            nxtLineExpo = parseFloat(nxtLineExpo) - parseFloat(bet.amount)
                        }
                    } else if (bet.side.toLowerCase() === "lay") {
                        if (bet.runnerId > nxtLine) {
                            nxtLineExpo = parseFloat(nxtLineExpo) + parseFloat(bet.amount)
                        } else {
                            nxtLineExpo = parseFloat(nxtLineExpo) - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount))
                        }
                    }

                })
                lineExpos[prvLine] = { expo: prvLineExpo }
                lineExpos[thisLine] = { expo: thisLineExpo }
                lineExpos[nxtLine] = { expo: nxtLineExpo }
            }
        }
        //i = parseFloat(i) + 0.0001000000000
    }
    let lineExpoArr = Object.keys(lineExpos).map((line) => { return line = lineExpos[line].expo })
    expo = Math.min(...lineExpoArr)
    let data = { expo: expo, lineExpos: lineExpos }
    return data
}
